var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as OptionValueFactory from "../../classes/definitions/optionType/optionValue";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import OptionValuesList from '../../components/OptionValues/OptionValuesList/OptionValuesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./OptionValuesReduxProps";
var OptionValues = /** @class */ (function (_super) {
    __extends(OptionValues, _super);
    function OptionValues() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllOptionValues = function (pageNum) {
            _this.api.getOptionValues(_this.parentId, pageNum)
                .then(function (response) {
                var values = OptionValueFactory.createOptionValues(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: values, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим Option Values.', _this.props.history);
            });
        };
        _this.toNewOptionValue = function () {
            _this.props.history.push(AppRoutes.optionType.path + '/' + _this.parentId + AppRoutes.optionValue.path);
        };
        _this.toEditOptionValue = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.optionType.path + '/' + _this.parentId + AppRoutes.optionValue.path + ("/" + selectedId));
            }
        };
        _this.toParentOptionType = function () {
            _this.props.history.push(AppRoutes.optionType.path + '/' + _this.parentId);
        };
        return _this;
    }
    OptionValues.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        if (this.parentId !== '-1') {
            this.getAllOptionValues(1);
        }
    };
    OptionValues.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "Option Values"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewOptionValue, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 Option Value"),
                            React.createElement("a", { onClick: this.toParentOptionType },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(OptionValuesList, { gridData: data, edit: this.toEditOptionValue, meta: meta, getAllOptionValues: this.getAllOptionValues }))))));
    };
    return OptionValues;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(OptionValues);



//////////////////
// WEBPACK FOOTER
// ./src/views/OptionValues/OptionValues.tsx
// module id = 383
// module chunks = 0